module.exports = __webpack_public_path__ + "static/sw-badge-back-7acaf8a143eca94888d7015fd9879fb7.png";